import { useEffect, useRef, useState } from 'react';

/**
 * Обрезан ли однострочный текст элемента ellipsis'ом. Пересчитывается на ресайз
 * самого элемента (ResizeObserver): ширина шапки позиции и aside-панели меняется
 * без ре-рендера, а подсказка нужна ровно тогда, когда текст не поместился.
 *
 * @param watch значение, при смене которого проверку надо повторить (обычно сам текст)
 */
export const useIsTruncated = <T extends HTMLElement>(watch?: unknown) => {
    const ref = useRef<T>(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const check = () => setIsTruncated(el.scrollWidth > el.clientWidth + 1);
        check();

        const ro = new ResizeObserver(check);
        ro.observe(el);
        return () => ro.disconnect();
    }, [watch]);

    return { ref, isTruncated };
};
